import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  SharedAuthSessionManager,
  SharedAuthSessionOptions,
  SharedInvalidSessionHandler,
} from '@share-auth-session';
import { AuthActions } from '../store/state/auth/auth.actions';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class ChatSharedAuthSessionManager implements SharedAuthSessionManager {
  constructor(
    private authService: AuthService,
    private store$: Store,
  ) {}

  public async ensureValidSession(
    options: SharedAuthSessionOptions,
  ): Promise<boolean> {
    const isValid = await this.authService.ensureValidSession(options);

    if (!isValid && !this.authService.hasStoredSession()) {
      this.store$.dispatch(AuthActions.logout({ msg: 'Session is expired' }));
    }

    return isValid;
  }
}

@Injectable({
  providedIn: 'root',
})
export class ChatInvalidSessionHandler implements SharedInvalidSessionHandler {
  private logoutDispatched = false;

  constructor(private store$: Store) {}

  public handleInvalidSession(): void {
    if (this.logoutDispatched) {
      return;
    }

    this.logoutDispatched = true;
    this.store$.dispatch(AuthActions.logout({ msg: 'Session is invalid' }));
  }
}
